export const bookingTypes = {
    DAILY_BOOKING: 'daily',
    HOURLY_BOOKING: 'hourly',
    BLOCK_BOOKING: 'block',
};

export const typesWithTimeSelection = [
    bookingTypes.BLOCK_BOOKING,
    bookingTypes.HOURLY_BOOKING,
];

export const blockDurationOptions = [
    15,
    30,
    60,
    120,
];

export const defaultBlockDuration = 60;
